import { BundledProduct, Contract, MyProfileData } from 'cpfr-common';
import { NotificationStatus } from '@cp-shared-19/frontend-ui';
import { Accordion, Hr, Notification } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { emptyObjectOrAllValuesAreUndefined } from '../../../../utils';
import { BundledProductComponent } from './bundled-product/BundledProduct';

type BundledProductsProps = {
    contract?: Contract;
    isSMECustomer?: boolean;
    bundledProductsDetails?: BundledProduct[];
    contractMileage?: number;
    myProfileData?: MyProfileData;
};

export const BundledProducts: React.FC<BundledProductsProps> = ({
    contract,
    isSMECustomer,
    bundledProductsDetails,
    contractMileage,
    myProfileData,
}) => {
    const { t } = useTranslation('bundled-products');

    if (!contract || !bundledProductsDetails) {
        return null;
    }

    const bundledProductsList = bundledProductsDetails.map((bundledProductDetails, index) => (
        <div className={index !== bundledProductsDetails.length - 1 ? 'u-mb' : ''} key={index}>
            {!!index && <Hr className={'u-mv'} />}
            <BundledProductComponent
                isSMECustomer={isSMECustomer}
                details={bundledProductDetails}
                contractMileage={contractMileage}
                myProfileData={myProfileData}
            />
        </div>
    ));

    const isError =
        !bundledProductsDetails.length ||
        bundledProductsDetails.every((bundledProduct) => emptyObjectOrAllValuesAreUndefined(bundledProduct));

    return (
        <Accordion.Item
            title={t('title')}
            titleLevel={4}
            contentClassName={'u-pr-none'}
            id={`bundled-products-${contract?.contractId}`}
        >
            {isError ? (
                <Notification
                    status={NotificationStatus.info}
                    testId={'not-found-error'}
                    title={''}
                    hideTitle={true}
                    visible
                    showCloseButton={false}
                >
                    {t('info')}
                </Notification>
            ) : (
                <div>{bundledProductsList}</div>
            )}
        </Accordion.Item>
    );
};
